import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'app-tab-toggle-option',
  templateUrl: './tab-toggle-option.component.html',
  styleUrls: ['./tab-toggle-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabToggleOptionComponent implements OnInit {
  @HostBinding('class.active')
  @Input()
  active?: boolean;

  constructor() {}

  ngOnInit(): void {}
}
